<script>
	var email="", phone="", appointment, apptField, loading;
	$: if(apptField){
		apptField.focus();
	}
	function signUp(){
		if (email == "" || phone == "") {
            alert("Please enter your details, thanks!");
            return;
        }
        var formdata = new FormData();
        	formdata.append("entry.1104958657", email);
            formdata.append("entry.517257960", phone);
        loading = true;
		fetch(
            "https://docs.google.com/forms/u/0/d/e/1FAIpQLSeU1AvNPtoblvAUOqW352_DFMjZ-Uoz1OwbDzHISjVOCGUH7A/formResponse",
            { method: "POST", body: formdata, mode: "no-cors" }
        )
            .then((r) => r.text())
            .then((r) => {
                loading = "show";
            });
	}
</script>
<main>
	<section class="bg-gray-200 py-20 lg:py-28"><!-- Start Hero Block -->
		<div class="container mx-auto px-5 text-center">
			<div class="mb-16">
				<div class="space-y-4 mb-12">
					<h4 class="text-2xl sm:text-3xl font-semibold">Colmo POS</h4>
					<h1 class="text-5xl sm:text-7xl font-bold">Smart & Simple</h1>
					<p class="sm:w-3/4 lg:w-2/4 xl:w-96 mx-auto text-lg sm:text-xl text-gray-600">Cloud POS Solution with QR Ordering. 15 minutes training. Fits all types of restaurant operations.</p>
				</div>
				<button on:click="{()=>appointment=true}" class="px-12 py-4 bg-blue-800 hover:bg-blue-900 transition duration-300 ease-in-out shadow hover:shadow-lg transform hover:scale-110 text-white font-semibold text-lg rounded-full inline-block">Buy now</button>
			</div>
			<img class="mx-auto xl:max-w-screen-lg mb-28" src="assets/img/main1.png" alt="Drone">
			<div class="space-y-12">
				<p class="lg:w-3/5 mx-auto text-xl sm:text-3xl font-semibold text-gray-600">Optimised for the new normal. Operate your restaurants with modern technologies, and run your operations with minimal workforce.</p>
				<div class="flex flex-col sm:flex-row justify-center space-y-5 sm:space-y-0 sm:space-x-10 md:space-x-20">
					<div class="flex flex-col sm:flex-row items-center space-y-3 sm:space-y-0 sm:space-x-4 sm:text-left">
						<span class="flex items-center justify-center h-12 w-12 rounded-full bg-white shadow text-gray-600">
							<svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
								<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
							  </svg>
						</span>
						<span class="font-medium text-gray-600">Supports Franchise Operations. Individual franchisee access to the Cloud.</span>
					</div>
					<div class="flex flex-col sm:flex-row items-center space-y-3 sm:space-y-0 sm:space-x-4 sm:text-left">
						<span class="flex items-center justify-center h-12 w-12 rounded-full bg-white shadow text-gray-600">
							<svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
								<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z" />
							  </svg>
						</span>
						<span class="font-medium text-gray-600">QR Ordering Support. Enable contactless ordering for all your customers.</span>
					</div>
					<div class="flex flex-col sm:flex-row items-center space-y-3 sm:space-y-0 sm:space-x-4 sm:text-left">
						<span class="flex items-center justify-center h-12 w-12 rounded-full bg-white shadow text-gray-600">
							<svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
								<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
							  </svg>
						</span>
						<span class="font-medium text-gray-600">Up to 50 Terminals. Set up table ordering kiosks or waiter ordering tablets.</span>
					</div>
				</div>
			</div>
		</div>
	</section><!-- End Hero Block -->

	<section class="py-10 lg:py-14 pt-16 lg:pt-28"><!-- Start Second Block -->
		<div class="container mx-auto px-5">
			<div class="space-y-5 text-center mb-8 lg:mb-16">
				<h4 class="text-3xl font-semibold text-gray-600">QR Ordering</h4>
				<h2 class="text-4xl sm:text-5xl font-bold">Contactless Orders</h2>
				<p class="sm:w-3/4 lg:w-2/4 xl:w-1/3 mx-auto text-lg sm:text-xl text-gray-600">The new normal demands new solutions. No longer does your customers have to 'wait' for waiters. Through smartphones, your customers can place orders directly to your kitchen.</p>
			</div>
			<div class="xl:w-4/5 mx-auto flex items-center justify-center">
				<img src="assets/img/qrOrder2.png" alt="">
			</div>
		</div>
	</section><!-- End Second Block -->

	<section class="py-10 lg:py-14"><!-- Start Third Block -->
		<div class="container mx-auto px-5">
			<div class="space-y-5 lg:text-center mb-8 lg:mb-16">
				<h2 class="text-4xl sm:text-5xl font-bold">The Power of the Cloud</h2>
				<p class="sm:w-3/4 lg:w-2/4 xl:w-1/3 lg:mx-auto text-lg sm:text-xl text-gray-600">View the performance of your business online, from anywhere, on any devices.</p>
			</div>
			<div class="grid gap-y-10 lg:gap-y-0">
				<div class="grid lg:grid-cols-2 gap-5 lg:gap-0 items-center">
					<div class="space-y-4 lg:pr-20">
						<h3 class="text-2xl sm:text-4xl font-semibold">Manage your products</h3>
						<p class="text-lg text-gray-600">
							Keep your menu fresh and always up to date with Colmo Cloud's products manager. Easily modify pricing, add modifiers or add/edit products straight from your web browser.
						</p>
						<p class="text-lg text-gray-600">
							<b>Import/Export from Excel</b> is also supported. Simply download our excel template and upload it to Colmo Cloud, and your menu will reflect the latest changes.
						</p>
					</div>
					<div class="bg-gray-100 p-12">
						<img class="rounded-2xl" src="assets/img/feature1.png" alt="">
					</div>
				</div>
				
				<div class="grid lg:grid-cols-2 gap-5 lg:gap-0 items-center">
					<div class="bg-gray-100 p-12 order-last lg:order-first">
						<img class="rounded-2xl" src="assets/img/feature2.png" alt="">
					</div>
					<div class="space-y-4 lg:pl-20">
						<h3 class="text-2xl sm:text-4xl font-semibold">Live report updates</h3>
						<p class="text-lg text-gray-600">
							Keep track of your sales at all times, find out what's the total collection of the day. 
						</p>
						<p class="text-lg text-gray-600">
							We even keep track of various statistics so you can make better decisions for your business, see how well takeaway/deliveries are doing, find out if your promotions are working.
						</p>
					</div>
				</div>

				<div class="grid lg:grid-cols-2 gap-5 lg:gap-0 items-center">
					<div class="space-y-4 lg:pr-20">
						<h3 class="text-2xl sm:text-4xl font-semibold">Simple supply management</h3>
						<p class="text-lg text-gray-600">
							It's easy to keep track of usage and wastage in your outlets. Our cloud provides a summary of ingredients used daily, which you can compare against your supply orders to determine abnormalies or wastage.
						</p>
					</div>
					<div class="bg-gray-100 p-12">
						<img class="rounded-2xl" src="assets/img/feature3.png" alt="">
					</div>
				</div>
			</div>
		</div>
	</section><!-- End Third Block -->

	<section class="py-10 lg:py-14 pb-20 lg:pb-28 bg-gray-100"><!-- Start Fourth Block -->
		<div class="container mx-auto px-12 sm:px-5">
			<div class="space-y-5 text-center mb-8 lg:mb-16">
				<h2 class="text-4xl sm:text-5xl font-bold">Features that you want</h2>
				<p class="sm:w-3/4 lg:w-2/4 xl:w-1/3 mx-auto text-lg sm:text-xl text-gray-600">Advanced features available to your business at one flat rate, no hidden charges</p>
			</div>
			<div class="grid sm:grid-cols-2 lg:grid-cols-3 gap-10">
				<div class="space-y-6 text-center">
					<svg xmlns="http://www.w3.org/2000/svg" class="h-14 w-14 mx-auto text-blue-800" fill="none" viewBox="0 0 24 24" stroke="currentColor">
						<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01" />
					  </svg>
					<div class="space-y-4">
						<h5 class="text-2xl font-semibold">Split Billing</h5>
					<p class="text-lg text-gray-600">Split out bills easily for customers, our interface makes it simple to produce receipts for company claims</p>
					</div>
				</div>
				<div class="space-y-6 text-center">
					<svg xmlns="http://www.w3.org/2000/svg" class="h-14 w-14 mx-auto text-blue-800" fill="none" viewBox="0 0 24 24" stroke="currentColor">
						<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
					  </svg>
					<div class="space-y-4">
						<h5 class="text-2xl font-semibold">Digital Receipts</h5>
						<p class="text-lg text-gray-600">Send a digital invoice to your customers via Email or Whatsapp, in beautiful PDF format</p>
					</div>
				</div>
				<div class="space-y-6 text-center">
					<svg xmlns="http://www.w3.org/2000/svg" class="h-14 w-14 mx-auto text-blue-800" fill="none" viewBox="0 0 24 24" stroke="currentColor">
						<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 17h2a2 2 0 002-2v-4a2 2 0 00-2-2H5a2 2 0 00-2 2v4a2 2 0 002 2h2m2 4h6a2 2 0 002-2v-4a2 2 0 00-2-2H9a2 2 0 00-2 2v4a2 2 0 002 2zm8-12V5a2 2 0 00-2-2H9a2 2 0 00-2 2v4h10z" />
					  </svg>
					<div class="space-y-4">
						<h5 class="text-2xl font-semibold">Advanced Printing</h5>
						<p class="text-lg text-gray-600">Configure how orders should print to various areas of your outlet, set items configurable</p>
					</div>
				</div>
				<div class="space-y-6 text-center">
					<svg xmlns="http://www.w3.org/2000/svg" class="h-14 w-14 mx-auto text-blue-800" fill="none" viewBox="0 0 24 24" stroke="currentColor">
						<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
					  </svg>
					<div class="space-y-4">
						<h5 class="text-2xl font-semibold">Customer Display</h5>
						<p class="text-lg text-gray-600">Display the current cart information to your customers, upsell your products and get feedback</p>
					</div>
				</div>
				<div class="space-y-6 text-center">
					<svg xmlns="http://www.w3.org/2000/svg" class="h-14 w-14 mx-auto text-blue-800" fill="none" viewBox="0 0 24 24" stroke="currentColor">
						<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 18h.01M7 21h10a2 2 0 002-2V5a2 2 0 00-2-2H7a2 2 0 00-2 2v14a2 2 0 002 2z" />
					  </svg>
					<div class="space-y-4">
						<h5 class="text-2xl font-semibold">Customer Kiosk</h5>
						<p class="text-lg text-gray-600">Enable your customers to order right from the table with our beautiful and easy to use interface</p>
					</div>
				</div>
				<div class="space-y-6 text-center">
					<svg viewBox="0 0 1920 1920" class="h-14 w-14 mx-auto text-blue-800" id="table" fill="none" stroke="currentColor">
						<path stroke-linecap="round" stroke-linejoin="round" stroke-width="60"
						  d="M216.4 1345.8l94.3 12.9V682.6l-94.3-8.6zM715.9 1107l70.4 6.9V836.3l-70.4-7zm829.3 88.4l94.2 12.8V670l-94.2 49.1z">
						</path>
						<path stroke-linecap="round" stroke-linejoin="round" stroke-width="60"
						  d="M715.9 435.5L216.4 673.3l94.3 9.2 820.7 80v709.3l94.3 12.7V771.7l64.1-33.4 349.6-182 63.1-32.8z">
						</path>
						<path stroke-linecap="round" stroke-linejoin="round" stroke-width="60"
						  d="M310.7 682.6v676.1l64-30.3v-533l341.2 33.9 70.4 7v277.6l65.7-36.8V842.8l279.4 27.7v-108l-820.7-80zm1391.8-159.1l-63.1 32.8-349.6 182-64.1 33.4v712.8l64.1-53.7V852l255.4-132.9 94.2-49.1v538.2h.1l64.1-53.8V523.5z">
						</path>
						<path stroke-linecap="round" stroke-linejoin="round" stroke-width="60"
						  d="M310.7 1358.7l-94.3-12.9V674l94.3 8.6v106.5zm915-587v712.8l-94.3-12.7V870.5L852 842.8l-65.7-6.5-70.4-7-341.2-33.9-64-6.3m1391.8-265.6l-986.6-88-499.5 237.8 94.3 9.2 820.7 80 94.3 9.2 64.1-33.4 349.6-182z">
						</path>
						<path stroke-linecap="round" stroke-linejoin="round" stroke-width="60"
						  d="M374.7 795.4v533l-64 30.3m915 125.8l64.1-53.7V738.3m0 113.7l255.4-132.9 94.2-49.1h.1m-853.2 443.9l-70.4-6.9V829.1M852 842.8v234.3l-65.7 36.8m0-278.8v278.8m345.1-243.4v-108">
						</path>
						<path stroke-linecap="round" stroke-linejoin="round" stroke-width="60"
						  d="M1639.4 556.3v651.9l-94.2-12.8V719.1m94.3 489.1l64.1-53.8V523.5"></path>
					  </svg>
					<div class="space-y-4">
						<h5 class="text-2xl font-semibold">Smart Table Layout</h5>
						<p class="text-lg text-gray-600">Easily rearrange tables at any time, get buffet time alerts and glancable table status at all time</p>
					</div>
				</div>
			</div>
		</div>
	</section><!-- End Fourth Block -->   
	<section class="py-10 lg:py-14"><!-- Start Third Block -->
		<div class="container mx-auto px-5">
			<div class="space-y-5 lg:text-center mb-8 lg:mb-16">
				<h2 class="text-4xl sm:text-5xl font-bold">Our Clients</h2>
			</div>
		</div>
		<div class="grid grid-cols-3 lg:grid-cols-6 gap-8 px-6">
			<div class=""><img class="object-contain" src="assets/img/skg.jpg" /></div>
			<div class=""><img class="object-contain" src="assets/img/scpm.jpg" /></div>
			<div class=""><img class="object-contain" src="assets/img/uncle6.jpg" /></div>
			<div class=""><img class="object-contain" src="assets/img/butcher.jpg" /></div>
			<div class=""><img class="object-contain" src="assets/img/whp.jpg" /></div>
			<div class=""><img class="object-contain" src="assets/img/roofdeck.jpg" /></div>
		</div>
	</section>
	<section id="quote" class="bg-gray-100 py-20 lg:py-28"><!-- Start Fifth Block -->
		<div class="container mx-auto px-5">
			<div class="grid lg:grid-cols-2 gap-10 items-center text-center lg:text-left">
				<div class="space-y-8">
					<div class="space-y-4">
						<h2 class="text-3xl sm:text-5xl font-bold">Colmo POS</h2>
						<p class="text-xl text-gray-600">Smart & Simple POS for your business</p>
					</div>
					<div class="flex justify-center lg:justify-start items-center space-x-4">
						<button on:click="{()=>appointment = true}" class="inline-block rounded-full px-6 py-3 bg-white hover:bg-blue-900 text-blue-800 hover:text-white shadow transition duration-300 hover:shadow-lg text-lg font-semibold">Ask for quotation</button>
						<div class="text-xl font-semibold text-blue-800">From RM1,500</div>
					</div>
					{#if appointment}
					<div class="w-full lg:w-2/3 rounded-2xl p-4 bg-white shadow-lg">
						{#if loading && loading=='show'}
						<p class="text-center mt-4 mb-2">
							<svg xmlns="http://www.w3.org/2000/svg" class="h-24 w-24 inline-block text-green-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
								<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
							  </svg>
						</p>
						<p class="text-center text-lg mb-4">Thanks! We will be in touch soon.</p>
						{:else if loading}
						<p class="text-center mt-4 mb-2">
							<svg class="inline-block animate-spin w-20 h-20 text-blue-800" fill="none" viewBox="0 0 24 24">
								<circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
								<path class="opacity-75" fill="currentColor"
								  d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
								</path>
							  </svg>
						</p>
						<p class="text-center text-lg mb-4">Submitting Your Appointment Request..</p>
						{:else}
						<h2 class="text-gray-900 text-lg font-medium title-font mb-5">Appointment Form</h2>
						<div class="relative mb-4">
						  <label for="full-name" class="leading-7 text-sm text-gray-600">Name</label>
						  <input bind:this="{apptField}" bind:value="{email}" type="text" name="full-name" class="w-full bg-white rounded border border-gray-300 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-200 text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out">
						</div>
						<div class="relative mb-4">
						  <label for="email" class="leading-7 text-sm text-gray-600">Phone</label>
						  <input bind:value="{phone}" type="phone" name="phone" class="w-full bg-white rounded border border-gray-300 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-200 text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out">
						</div>
						<button on:click="{signUp}" class="text-white bg-indigo-500 border-0 py-2 px-8 focus:outline-none hover:bg-indigo-600 rounded text-lg">Contact Me</button>
						<p class="text-xs text-gray-500 mt-3">Please allow us 1-2 days time to arrange an appointment, thanks!</p>
						{/if}
					</div>
					{/if}
				</div>
				<div class="">
					<img src="assets/img/main2.png" alt="Drone">
				</div>
			</div>
		</div>
	</section><!-- Start Fifth Block -->

	<footer class="py-8 lg:py-12">
		<div class="container mx-auto px-5 text-center">
			<div class="flex flex-col md:flex-row justify-center space-y-2 md:space-y-0 md:space-x-4 text-sm text-gray-500 mb-6">
				<p>Copyright © 2023 Colmo POS. All rights reserved.</p>
				<p>Colmo Tech (NS0246417-H)</p>
			</div>
			<div class="sm:w-2/4 lg:w-1/3 mx-auto">
				<p class="text-xs text-gray-400">All imagery and illustration shown on this site are intellectual property of Colmo POS. Do not redistribute.</p>
			</div>
		</div>
	</footer>
</main>